module.exports = __webpack_public_path__ + "img/s4.875e2ccb.jpg";